module.exports = __webpack_public_path__ + "img/letter-j.45383002.svg";